import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { store } from './store';
import vuetify from './plugins/vuetify';

import VueHead from 'vue-head';
Vue.use(VueHead);

Vue.config.productionTip = false;

// cookie
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config('14d');

// ヘッダー
import AppHeader from '@/components/AppHeader.vue';
Vue.component('AppHeader', AppHeader);

// Loading
import Loading from '@/components/Loading.vue';
Vue.component('Loading', Loading);

// Alert
import Alert from '@/components/Alert.vue';
Vue.component('Alert', Alert);

// import 'babel-polyfill';

// axios
// eslint-disable-next-line no-unused-vars
import axios, { AxiosInstance } from 'axios';
const http: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    responseType: 'json',
});

const httpfile: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_TMP_BASE_URL,
});

declare module 'vue/types/vue' {
    interface Vue {
        $http: AxiosInstance;
        $httpfile: AxiosInstance;
    }
}
Vue.prototype.$http = http;
Vue.prototype.$httpfile = httpfile;

new Vue({
    router,
    store,
    vuetify,
    head: {
        meta: [
            { charset: 'utf-8' },
            {
                name: 'viewport',
                content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0',
            },
        ],
    },
    render: h => h(App),
}).$mount('#app');
